export const orderState = {
    1: { orderstate: '已下单', },
    2: { orderstate: '取消' },
    3: { orderstate: '支付成功' },
    4: { orderstate: '退款' },
    5: { orderstate: '完成' },
}
export const runningStatus = {
    '0': { runningStatus: '运行', icon: 'el-icon-video-play' },
    '1': { runningStatus: '离线', icon: 'el-icon-video-pause' },
}
export const portStatus = {
    '0': { portStatus: '离线', },
    '1': { portStatus: '故障', },
    '2': { portStatus: '空闲', },
    '3': { portStatus: '充电', },
    '4': { portStatus: '已插枪', },
    '5': { portStatus: '占用', },
}
export const showStatus = {
    '0': { showStatus: '显示', },
    '1': { showStatus: '不显示', },
}
export const dataStatus = {
    '0': { dataStatus: '正常', },
    '1': { dataStatus: '禁用', },
}